const selectActionAlertsModalData = (state) => state.actionAlertsModalData;
export default selectActionAlertsModalData;
